<template>
    <div>
        <breadcrumb :routerList="[{to:'/shijipaodong',title:'用户交互'},{title:'周计划'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                    <h1>周计划信息</h1>
                                </div>
                                <!-- <div style="width:100%;height:1px;background:#dee1eb;margin-bottom:20px;"></div> -->
                                <div class="weekplans">
                                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                                        <!-- <el-form-item label="所在地址" style="width:40%">
                                            <el-input v-model="formInline.areaName" placeholder="用户区域" readonly></el-input>
                                        </el-form-item> -->
                                        <el-form-item label="时间范围" style="width:40%">
                                            <el-col :span="10">
                                                <el-input v-model="formInline.starttime" placeholder="开始时间" readonly></el-input>
                                                <!-- <el-date-picker disabled :clearable="false" type="date" placeholder="开始时间" v-model="formInline.starttime" style="width: 1.6rem;"></el-date-picker> -->
                                            </el-col>
                                            <el-col :span="2" style="margin-left:10px">至&nbsp; </el-col>
                                            <el-col :span="10">
                                                <el-input v-model="formInline.endtime" placeholder="结束时间" readonly></el-input>
                                                <!-- <el-date-picker disabled :clearable="false" type="date" placeholder="结束时间" v-model="formInline.endtime" style="width: 1.6rem;"></el-date-picker> -->
                                            </el-col>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="h-rowBox" style="margin-top:30px;">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>销售服务</h1>
                                    <div class="mubiaoBox">
										<div class="mubiao">
											<div class="mubiaobutton"></div>
											<div class="mubiaotext">已达成</div>
										</div>
										<div class="mubiao" style="margin-left:20px;">
											<div class="mubiaobutton" style="background:#fec02a"></div>
											<div class="mubiaotext">目标</div>
										</div>
									</div>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin-bottom:20px;"></div>
                                <div class="h-pieChart" id="h_line1Chart" style="width: 100%; height: 6.7rem;"></div>
                            </div>
                        </div>
                    </div> -->
                    <div class="h-rowBox week" style="margin-top:30px;">
                        <div class="h-rowCon ljjtablepaddingsweekplan" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>周计划列表</h1>
                                </div>
                            </div>
                            <el-table
                                    ref="multipleTable"
                                    :data="tableData3"
                                    @selection-change="handleSelectionChange"
                                    stripe
									border
                                    style="width: 100%"
                            >
                                <el-table-column
                                        type="index"
                                        width="40"
                                        label="#">
                                </el-table-column>
                                <el-table-column
                                        prop="times"
                                        label="拜访时间"
                                        width="373">
                                    <template scope="scope">
                                        <el-date-picker
                                                class="h-tableInput weekplaninputs"
                                                :clearable="false"
                                                v-model="scope.row.times"
                                                type="daterange"
                                                range-separator="至"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                prefix-icon='el-icon-date'
                                        >
                                        </el-date-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="euType"
                                        label="用户类型"
                                        width="130">
                                    <template scope="scope">
                                        <el-select class="h-tableInput" v-model="scope.row.euType" placeholder="请选择" @change="customerType(scope.row)">
                                            <el-option  v-for="(item) in options2"
                                                        :key="item.code"
                                                        :label="item.name"
                                                        :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="euName"
                                        label="拜访对象"
                                        width="220">
                                    <template scope="scope">
                                        <el-select class="h-tableInput" v-model="scope.row.euName" filterable remote placeholder="模糊搜索拜访对象"
                                                     :remote-method="showFormList" @change="showForm(scope.row)">
                                            <el-option  v-for="(item) in EuName"
                                                        :key="item.userCode"
                                                        :label="item.userName"
                                                        :value="item.userName">
                                            </el-option>
                                        </el-select>
                                        <!--<el-select v-else-if="scope.row.euType==2"  v-model="scope.row.euName"
                                                   filterable remote :remote-method="customerOptions(scope.row.euName)"
                                                   placeholder="请选择">
                                            <el-option  v-for="(item) in optionsCustomer"
                                                        :key="item.userCode"
                                                        :label="item.userName"
                                                        :value="item.userName">
                                            </el-option>
                                        </el-select>
                                        <el-input v-else-if="!scope.row.euType"  v-model="scope.row.euName">
                                        </el-input>-->
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="contactDept"
                                        label="部门/科室"
                                        width="170">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.contactDept" placeholder="请输入部门科室" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="contact"
                                        label="联系人"
                                        width="170">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.contact" placeholder="请输入联系人" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="contactPhone"
                                        label="联系人电话"
                                        width="170">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.contactPhone" placeholder="请输入联系人电话" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="planRemark"
                                        label="洽谈内容"
										min-width="250"
                                >
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.planRemark" placeholder="洽谈内容" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="120" fixed="right">
                                    <template slot-scope="scope">
										<el-button type="text" size="small" class="h-tableLink h-btn" @click="delPlan(scope.$index)">删除</el-button>
										<el-button type="text" size="small" class="h-tableLink h-btn" @click="copyPlan(scope.row)">复制</el-button>
										<!-- <div class="l-operationBox">
											<span class="l-operationlist br-operation-delete" title="删除" @click="delPlan(scope.$index)"></span>
											<span class="l-operationlist br-operation-copy" title="复制" @click="copyPlan(scope.row)"></span>
										</div> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="h-tableAdd" @click="add">
                                <a>新增一行</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="isCheck==1" class="h-txtCenter h-mrt60">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPlan">返回</el-button>
                        <el-button class="h-btn h-bBtn h-bggreen" @click="submitPlan(0)">暂存</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitPlan(1)">确认提交</el-button>
                    </div>
                    <div v-if="isCheck!=1" class="h-txtCenter h-mrt60">
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="cancelPlan">返回</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService';
    export default {
        data(){
            let that=this
            return{
                f:{
                    userName:null,
                },
                EuName:[],
                all: "全部",
                formInline:{
                    names:'',
                    starttime: '',
                    endtime:'',
                    areaName:''
                },
                isCheck:1,
                pickerOptions:{
                    disabledDate(time){
                        let endDate=that.formInline.endtime;
                        let startDate=that.formInline.starttime;
                        return time.getTime()<(new Date(startDate).getTime()-24*60*60*1000) || time.getTime()>(new Date(endDate).getTime()+15*60*60*1000)
                    }
                },
                options2:[],
                tableData3: [
                    {
                        times: [],
                        code:null,
                        euType: null,
                        euCode: null,
                        euName: null,
                        province: null,
                        city: null,
                        county: null,
                        address: null,
                        planRemark:null,
                        contact:null,
                        contactPhone:null,
                        contactDept:null
                    }
                ],
                optionsCustomer:[],
                optionsAgent:[],
                userCarePlan:{},
                inputtext:null,
            }
        },
        methods:{
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            add(){
                var list = {
                    times: [],
                    code:'',
                    euType: '',
                    euName: '',
                    euCode: '',
                    province: '',
                    city: '',
                    county: '',
                    address: '',
                    contact:'',
                    contactPhone:'',
                    contactDept:'',
                    planRemark:''
                }
                this.tableData3.push(list)
            },
            customerType(v){
                v.euCode=null;
                v.euName=null;
                v.channelCode=null;
                v.areaCode=null;
                v.contactDept=null;
                v.contact=null;
                v.contactPhone=null;
                this.EuName=null;
                if(v.euType == 1){
                    this.inputtext ='经销商'
                }else{
                    this.inputtext ='用户'
                }
            },
            delPlan(index){
                this.tableData3.splice(index, 1)
                //console.log(index,"删除一行数据");
            },
            copyPlan(v){
                var list = {
                    times: v.times,
                    code:v.code,
                    euType: v.euType,
                    euName: v.euName,
                    euCode: v.euCode,
                    contactDept:v.contactDept,
                    contact:v.contact,
                    contactPhone:v.contactPhone,
                    province: v.province,
                    city: v.city,
                    county: v.county,
                    address: v.address,
                    planRemark: v.planRemark
                }
                this.tableData3.push(list)
            },
            //初始化周计划
            weekPlanM(){

                if(this.$route.query.taskstatus&&this.$route.query.taskstatus==1){
                    //代办已审核的查看页
                    this.isCheck=2;
                    var plan={"careWeek":this.$route.query.ywid};
                    //查询这个用户提交审核的周计划
                    ss.UserCare.weekPlanDetailFirst(plan).then(rd => {
                        console.log("初始化计划代办查看",rd);
                        this.formInline.area = rd.map.planWeek.areaCode;
                        this.formInline.userName = rd.map.planWeek.cuname;
                        this.formInline.areaName = this.$getDictName('YLRegion', rd.map.planWeek.areaCode);
                        this.formInline.starttime=rd.map.planWeek.weekPlanStart.split(' ')[0];
                        this.formInline.endtime=rd.map.planWeek.weekPlanEnd.split(' ')[0];
                        this.formInline.careWeek=this.$route.query.ywid;
                        if(rd.map.planDraft&&rd.map.planDraft.length>0){
                            this.tableData3=rd.map.planDraft;
                            this.tableData3.forEach((item, index)=>{
                                item.times=[item.planTimeStart,item.planTimeEnd];
                            })
                        }
                    })
                }else{
                    this.formInline.area = this._user.area;
                    this.formInline.areaName = this.$getDictName('YLRegion', this._user.area);
                    //查询这个用户有没有暂存状态的周计划和周计划时间范围
                    ss.UserCare.weekPlanFirst({}).then(rd => {
                        this.formInline.starttime=rd.map.planWeek.weekPlanStart.split(' ')[0];
                        this.formInline.endtime=rd.map.planWeek.weekPlanEnd.split(' ')[0];
                        this.formInline.careWeek=rd.map.planWeek.careWeek;
                        if(rd.map.planDraft&&rd.map.planDraft.length>0){
                            this.tableData3=rd.map.planDraft;
                            this.tableData3.forEach((item,index)=>{
                                if(item.instid){
                                    //如果有审批id
                                    this.formInline.instid=item.instid;
                                    this.formInline.ywid=item.careWeek;
                                }
                            })
                        }
                    })
                }

            },
            cancelPlan(){
                this.$router.go(-1);
            },
            showFormList(value) {
                if(value!=null){
                    this.f.userName = value;
                    if ( this.inputtext == '经销商') {
                        ss.UserCare.agentOption(this.f).then(rd => {
                            this.EuName = rd;
                        })
                    } else if (this.inputtext == '用户') {
                        ss.UserCare.customerOption(this.f).then(rd => {
                            this.EuName = rd;
                        })
                    }
                }
            },
            showForm(v){
                let obj = {};
                    obj = this.EuName.find((item)=>{//这里的userList就是上面遍历的数据源
                        return item.userName === v.euName;//筛选出匹配数据
                    });
                v.euCode=obj.userCode;//我这边的name就是对应label的
                v.contactDept=obj.department?obj.department:'';
                v.contact=obj.contactuserName?obj.contactuserName:'';
                v.contactPhone=obj.telephone?obj.telephone:'';
            },
            //保存交互周计划 0-草稿 1-提交
            submitPlan(v){
                let msg="确认提交审核交互周计划?";
                let msg2="已提交成功，请联系徐嘉鑫审核";
                if(v==0){
                    msg="确认保存交互周计划?";
                    msg2="保存成功";
                }
                var valFlag=true;
                this.tableData3.forEach((item, index) => {
                    item.planTimeStart=item.times[0];
                    item.planTimeEnd=item.times[1];
                    item.careWeek=this.formInline.careWeek;
                    if(v==1){
                        //校验
                        if(!item.planTimeStart||!item.planTimeEnd||!item.euType||!item.euCode){
                            this.$msg.msge("请完善信息后再提交审核");
                            valFlag=false;
                        }
                    }
                })
                if(valFlag){
                    this.$msg.confirm(msg,()=>{
                        this.userCarePlan.planStatus=v;
                        if(this.formInline.ywid){
                            this.userCarePlan.careWeek=this.formInline.ywid;
                        }else{
                            this.userCarePlan.careWeek=this.formInline.careWeek;
                        }
                        this.userCarePlan.instid=this.formInline.instid;
                        this.userCarePlan.planList=this.tableData3;
                        ss.UserCare.savePlan(this.userCarePlan).then(rd => {
                            this.$msg.msgs(msg2);
                            this.$store.dispatch('searchTasktotal');
                            this.$router.go(-1);
                        })
                    })
                }
            }

        },
        mounted(){
            //this.lineChart1();
            this.weekPlanM();
        },
        beforeCreate(){
            if(this.$route.query.taskstatus==1){
                this.$router.push({path: "/weekplan_detail",query: {ywid: this.$route.query.ywid,taskstatus:this.$route.query.taskstatus,instid:this.$route.query.instid}});

            }
        },
        created(){
            this.options2 = this.$store.getters.dicts["userCareType"];
        }
    }
</script>
<style>
    .week .el-date-editor .el-range-separator{
        width: 9%;
    }
    .h-content .h-rowBox.week{
        padding: 0;
    }
    .week .el-range-editor.el-input__inner{
        width: 356px;
    }
    .weekplans .h-formBorder .el-input__inner{
        border: 0;
        border-bottom: 1px solid #d1d1d1;
    }
    .weekplans .h-formBorder .el-form-item__content{
        width: 70%;
    }
    .dateget.el-date-editor .el-range-separator{
        width: 8%
    }
    .dateget.el-date-editor .el-range-input{
        width: 53%
    }
	.ljjtablepaddingsweekplan .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddingsweekplan .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
	.weekplaninputs.el-input__inner{
		border: none;
		height: 0.3rem;
		line-height: 0.3rem;
	}
	.weekplaninputs.el-date-editor .el-range-separator{
		line-height: 0.24rem;
	}
</style>
<style scoped>

    .mubiaoBox{
        display: flex;
        justify-content: center;
    }
    .mubiaoBox .mubiao{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mubiaoBox .mubiao .mubiaobutton{
        width: 30px;
        height: 18px;
        background: #4f8bfe;
    }
    .mubiaoBox .mubiao .mubiaotext{
        margin-left: 20px;
        color: #595959;
        font-size: 14px;
    }
</style>
